module.exports = __webpack_public_path__ + "static/media/Formato_Cargar_Ordenes.999a49e5.xlsx";